module.exports = __webpack_public_path__ + "img/computer@2x.c52794a4.png";